import PlayVideo from "../helpers/PlayVideo";
import noUnityChrome from "../helpers/noUnityChrome";

export default function () {
	new PlayVideo();

	noUnityChrome();
}
